<template>
    <div>
        <el-dialog title="交接班数据录入" :visible.sync="visible" center width="800px" @close="close"
            :close-on-click-modal="false">
            <el-form :model="form" ref="form" :rules="rules" label-width="120px" :inline="false" size="small" >
                <el-form-item label="日期" prop="workDate">
                    <el-date-picker v-model="form.workDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="班组" prop="team">
                    <el-select clearable collapse-tags filterable v-model="form.team" maxlength="16" placeholder="班组">
                        <el-option v-for="item in teamList" :key="item.id" :value="item.teamName"
                            :label="item.showName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="投入废布(kg)" prop="wasteTotalInput">
                    <el-input v-model="form.wasteTotalInput" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item label="设备运转情况" prop="deviceRunning">
                    <el-input v-model="form.deviceRunning" maxlength="100" type="textarea" placeholder="请输入"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="卫生情况" prop="hygiene">
                    <el-input v-model="form.hygiene" maxlength="50" type="textarea" placeholder="请输入"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="停机状况">
                    <i class="el-icon-circle-plus addIcon" @click="addStopMachine"></i>
                    合计停机时长：{{ totalStopTime }}小时
                    <div v-for="(item, index) in form.deviceHaltList" :key="index">
                        <el-form-item class="inlineForm" :prop="'deviceHaltList.'+index+'.type'"  :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                            <el-select v-model="item.type" style="width: 120px;" value-key="" placeholder=""  filterable size="mini">
                                <el-option v-for="item in DeviceHaltTypeOption" :key="item.key" :label="item.name" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="inlineForm" :prop="'deviceHaltList.'+index+'.startTime'"  :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                            <el-time-select
                                v-model="item.startTime" style="width: 100px;"
                                value-format="HH:mm"
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:10',
                                    end: '23:50'
                                }"
                                placeholder="选择时间">
                            </el-time-select>
                        </el-form-item>
                        至
                        <el-form-item class="inlineForm" :prop="'deviceHaltList.'+index+'.endTime'"  :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
                            <el-time-select
                                v-model="item.endTime" style="width: 100px;"
                                value-format="HH:mm"
                                :picker-options="{
                                    start: '00:00',
                                    step: '00:10',
                                    end: '23:50'
                                }"
                                placeholder="选择时间">
                            </el-time-select>
                        </el-form-item>
                        <el-form-item class="inlineForm" :prop="'deviceHaltList.'+index+'.reason'" >
                            <el-input v-model="item.reason" maxlength="50" style="width:200px" placeholder="停机原因描述 限50字"
                            clearable></el-input>
                        </el-form-item>
                        <i class="el-icon-delete delIcon" @click="delStopMachine(index)" ></i>
                    </div>
                </el-form-item>
                <el-form-item label="班组人员(多选)" prop="teamUserList">
                    <el-select v-model="form.teamUserList" value-key="" placeholder="请选择" clearable filterable multiple
                        collapse-tags>
                        <el-option v-for="item in userOption" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安全情况" prop="safetySituation">
                    <el-input v-model="form.safetySituation" maxlength="50" type="textarea" placeholder="请输入"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="接班人" prop="successorId">
                    <el-select v-model="form.successorId" value-key="" placeholder="请选择" clearable filterable
                        collapse-tags>
                        <el-option v-for="item in userOption" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <span slot="footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="submit">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
export default {
    name: "WorkshopShiftConfig",
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            DeviceHaltTypeOption: [],
            form: {
                workDate: "",
                team: "",
                wasteTotalInput: "",
                deviceRunning: "",
                hygiene: "",
                teamUserList: [],
                safetySituation: "",
                successorId: "",
                deviceHaltList: [
                    {
                        type: "",
                        startTime: null,
                        endTime: null,
                        reason: ""
                    }
                ]
            },
            rules: {
                workDate: [{ required: true, message: "请选择日期", trigger: "change" }],
                team: [{ required: true, message: "请选择班组", trigger: "change" }],
                wasteTotalInput: [{ required: true, message: "请输入投入废布", trigger: "blur" },
                //只允许填数字，只能到小数点2位
                {
                    validator: (rule, value, callback) => {
                        if (value == "") {
                            callback(new Error("请输入投入废布"));
                        } else {
                            if (!/^[0-9]+(.[0-9]{1,2})?$/.test(value)) {
                                callback(new Error("只允许填数字，只能到小数点2位"));
                            } else {
                                callback();
                            }
                        }
                    }
                }
                ],
                teamUserList: [{ required: true, message: "请选择班组人员", trigger: "change" }],
                successorId: [{ required: true, message: "请选择交接人", trigger: "blur" }]
            },
            userOption: [],
            teamList: [],
        };
    },
    computed: {
        name() {
            return this.data 
        },
        //计算合计停机时长
        totalStopTime() {
            let total = 0;
            this.form.deviceHaltList.forEach(item => {
                if(!item.startTime || !item.endTime){
                    return 0;
                }
                let start = item.startTime.split(":");
                let end = item.endTime.split(":");
                let time = (end[0] - start[0]) * 60 + (end[1] - start[1]);
                if(time > 0){
                    total += time;
                }else{
                    //跨天
                    total += 24*60 + time;
                }
            });
            //单位转为小时
            total = total / 60;
            //保留2位小数
            total = total.toFixed(1);
            return total; 
        }
    },
    mounted() {
        this.loadUserList();
        this.getDict("DeviceHaltType");
    },
    methods: {
        getDict(dict) {
            this.$RequestUtil.get({
                url: "/api/pull/list/list-dic",
                type: "sync",
                params: {
                bizCode: dict
                },
                success: res => {
                this[dict + "Option"] = res.data;
                }
            });
        },
        //获取班组列表
        async loadTeamList() {
            this.$RequestUtil.get({
                url: "/api/team-report/team-list",
                // type:'sync',
                params: {},
                success: res => {
                    if (res.code == 0) {
                        this.teamList = res.data;
                    } else {
                        this.$message.error(res.msg || res.message);
                    }
                }
            });
        },
        // 获取用户列表
        async loadUserList() {
            this.$RequestUtil.get({
                url: "/api/pull/list/user",
                params: {},
                success: res => {
                    if (res.code == 0) {
                        this.userOption = res.data;
                    } else {
                        this.$message.error(res.msg || res.message);
                    }
                }
            });
        },
        addStopMachine() {
           this.form.deviceHaltList.push({
               type:"",
               startTime:"",
               endTime:"",
               reason:""
           }) 
        },
        delStopMachine(index){
            this.form.deviceHaltList.splice(index,1);
        },
        close() {
           
            this.$refs.form.resetFields();
           
            this.$emit("update:visible", false)
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    //班组人员数组查找出对应用户对象
                    let teamUserList = this.form.teamUserList.map(item => {
                        return this.userOption.find(item2 => item2.id == item);
                    });
                    //从班组列表获取机组id
                    let team = this.teamList.find(item => item.teamName == this.form.team);
                    //从用户列表获取交接人对象
                    let successor = this.userOption.find(item => item.id == this.form.successorId);
                    //交接人对象添加到班组人员数组中

                    let deviceHaltList = this.form.deviceHaltList.map(e=>{
                        const haltType = this.DeviceHaltTypeOption.find(item => item.key == e.type);
                        return {
                            haltType:e.type,
                            haltName:haltType.name,
                            startTime:e.startTime,
                            endTime:e.endTime,
                            haltReason:e.reason
                        }
                    })

                    let params = {
                        ...this.form,
                        downTime: this.totalStopTime,
                        deviceHaltList: deviceHaltList,
                        teamUserList: teamUserList.map(item => {
                            return {
                                userId: item.id,
                                name: item.name,
                            }
                        }),
                        factoryModelId: team.factoryModelId,
                        factoryModelName: team.factoryModelName,
                        successor: successor.name,
                    }
                    this.$RequestUtil.post({
                        url: "/api/team-shift/create",
                        type: "sync",
                        params: params,
                        success: res => {
                            if (res.code == 0) {
                                this.$message.success("录入成功");
                                this.$refs.form.resetFields();
                                this.$emit("update:visible", false)
                            } else {
                                this.$message.error(res.msg || res.message);
                            }
                        }
                    });
                } else {
                    return false;
                }
            });
        }
    },
    watch: {
        visible(newValue, oldValue) {
           if(newValue){
            this.loadTeamList();
            this.form.deviceHaltList = [
                {
                    type: "",
                    startTime: null,
                    endTime: null,
                    reason: ""
                }
            ];
           } 
        }
    },
}
</script>

<style scoped>
.addIcon{
    cursor:pointer;
    color:#409eff;font-size:20px
}
.delIcon{
    cursor:pointer;
    color:#f56c6c;font-size:20px
}
.inlineForm{
    display:inline-block;
    margin-right:10px;
}
</style>


// WEBPACK FOOTER //
// src/views/order/ProductionTask/WorkshopShiftConfig.vue